<template>
  <div id="customers" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex mb-6 flex-wrap gap-4">
          <div class="">
            <div class="dropdown-button-container">
              <vs-dropdown :vs-trigger-click="true">
                <vs-button
                  class="btn-drop vs-component vs-button bg_l_green bg-danger w-full"
                  color="success"
                  icon="add"
                  :vs-trigger-click="true"
                  v-has-permission="permission78"
                  >{{ $t("CreateNewAgent") }}</vs-button
                >
                <vs-dropdown-menu id="agent-dp">
                  <router-link :to="{ path: '/Agents/CreateIndividual' }">
                    <vs-dropdown-item>
                      {{ $t("Individual") }}
                    </vs-dropdown-item>
                  </router-link>
                  <router-link :to="{ path: '/Agents/CreateLegal' }">
                    <vs-dropdown-item>
                      {{ $t("Legal") }}
                    </vs-dropdown-item>
                  </router-link>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="flex-grow flex gap-4 justify-end">
            <div>
              <vs-button
                @click="uploadFileForLegal()"
                class="bg_m_green float-right"
                v-if="fileUploadedForLegal"
                :disabled="disabledBtnForLegal"
                v-has-permission="permission319"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
              <label class="custom-file-upload">
                <input
                  type="file"
                  id="file"
                  ref="fileForLegal"
                  v-on:change="handleFileUploadForLegal()"
                />
                <div class="flex gap-2 items-start">
                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />{{ $t("CreateLegalAgentWithExcel") }}
                </div>
                <span v-if="uploadedFileNameForLegal" class="file-name">{{
                  uploadedFileNameForLegal
                }}</span>
              </label>
            </div>
            <div>
              <vs-button
                @click="uploadFileForIndividual()"
                class="bg_m_green float-right"
                v-if="fileUploadedForIndividual"
                :disabled="disabledBtn"
                v-has-permission="permission320"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
              <label class="custom-file-upload">
                <input
                  type="file"
                  id="file"
                  ref="fileForIndividual"
                  v-on:change="handleFileUploadForIndividual()"
                />
                <div class="flex gap-2 items-start">
                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />{{ $t("CreateIndividualAgentWithExcel") }}
                </div>
                <span v-if="uploadedFileNameForIndividual" class="file-name">{{
                  uploadedFileNameForIndividual
                }}</span>
              </label>
            </div>
            <vs-button
              @click.prevent="downloadExcelFile"
              class="bg_m_blue"
              :disabled="excelFileLoading"
              v-if="$tabHasPermission('GetAgentsWithExcelFile')"
            >
              <div class="flex gap-2 items-center">
                <span>{{ $t("DownloadExcelFile") }}</span>
                <img
                  v-if="excelFileLoading"
                  src="@/assets/images/loading.gif"
                  class="w-6 h-6"
                />
              </div>
            </vs-button>
            <filter-button @click="toggleShowFilters" />
          </div>
        </div>
        <form v-if="showFilters" class="filter-form">
          <div class="vx-row mb-6">
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
              <vs-input
                class="inputx mb-4"
                v-model="gridSearchData.Name"
                :label="$t('AgentName')"
              />
            </div>
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
              <label class="vs-select--label mb-1">{{ $t("AgentType") }}</label>
              <v-select
                label="name"
                :options="customers"
                v-model="gridSearchData.agentTypeQuery"
                :reduce="(x) => x.id"
                :clearable="false"
                ref="agentType"
                dir="rtl"
              >
              </v-select>
            </div>
            <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mt-6">
              <vs-button
                type="filled"
                class="float-right"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
              <vs-button
                type="filled"
                class="float-right"
                id="reset-btn"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
            </div>
          </div>
        </form>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              v-has-permission="permission240"
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name') },
                { title: $t('AgentID') },
                { title: 'کد نماینده' },
                {
                  title:
                    $t('SocialSecurityNumber') +
                    ' / ' +
                    $t('CompanyNationalId'),
                },
                { title: $t('PartyType') },
                { title: $t('Branch') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 16%">
                  <span v-if="row.partyType == 'AgentIndividual'">
                    {{ row.firstName }} {{ row.lastName }}
                  </span>
                  <span v-if="row.partyType == 'AgentLegal'">
                    {{ row.companyName }}
                  </span>
                </td>
                <td style="width: 8%">
                  {{ row.id }}
                </td>
                <td style="width: 8%">
                  {{ row.code }}
                </td>
                <td style="width: 15%">
                  <span v-if="row.socialSecurityNumber">
                    {{ row.socialSecurityNumber }}
                  </span>
                  <span v-if="row.companyNationalId">
                    {{ row.companyNationalId }}</span
                  >
                  <span
                    v-if="!row.socialSecurityNumber && !row.companyNationalId"
                    >-</span
                  >
                </td>
                <td style="width: 10%; direction: ltr">
                  <span v-if="row.partyType == 'AgentIndividual'">
                    {{ $t("Individual") }}
                  </span>
                  <span v-if="row.partyType == 'AgentLegal'">
                    {{ $t("Legal") }}
                  </span>
                </td>
                <td style="width: 8%; direction: ltr">
                  <span v-if="row.agentBranchInfo == 1">
                    <router-link
                      :to="{
                        path: '/Agents/CreateBranch/' + row.id,
                        query: {
                          breadcrumbNameManual: {
                            persianTitleParent: row.companyName,
                          },
                        },
                      }"
                    >
                      <vs-button
                        icon="icon-plus"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        class="custom-border-btn"
                        @click="onShowAddBranch(row)"
                        v-has-permission="permission878"
                        >{{ $t("AddBranch") }}</vs-button
                      >
                    </router-link>
                  </span>
                  <span v-else-if="row.agentBranchInfo == 2">شعبه</span>
                  <span v-else>--- </span>
                </td>
                <td style="width: 30%; direction: ltr">
                  <div
                    class="w-full h-full flex flex-wrap items-center justify-center gap-y-2"
                  >
                    <span v-if="row.partyType == 'AgentIndividual'">
                      <router-link
                        :to="{
                          path: '/Agents/EditIndividual/' + row.id,
                          query: {
                            ownerUserId: row.agentOwnerQuery.ownerId,
                            ownerUserName: row.agentOwnerQuery.agentOwnerName,
                          },
                        }"
                      >
                        <vs-button
                          radius
                          color="success"
                          size="small"
                          type="gradient"
                          icon-pack="feather"
                          icon="icon-edit"
                          class="d-inline"
                          v-has-permission="permission81"
                        ></vs-button>
                      </router-link>
                    </span>
                    <span
                      v-else-if="row.partyType == 'AgentLegal' && row.id != 0"
                    >
                      <router-link
                        :to="{
                          path: '/Agents/EditLegal/' + row.id,
                          query: {
                            ownerUserId: row.agentOwnerQuery.ownerId,
                            typeAgent: row.agentBranchInfo,
                          },
                        }"
                      >
                        <vs-button
                          radius
                          color="success"
                          size="small"
                          type="gradient"
                          icon-pack="feather"
                          icon="icon-edit"
                          class="d-inline"
                          v-has-permission="permission81"
                        ></vs-button>
                      </router-link>
                    </span>
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="custom-border-btn ml-2"
                      @click="onShowAgentSegment(row)"
                      v-has-permission="permission1319"
                      >{{ $t("Segment") }}</vs-button
                    >
                    <router-link
                      :to="{
                        path: '/AgentQuotas/' + row.id,
                        query: {
                          AgentName: row.firstName
                            ? row.firstName + ' ' + row.lastName
                            : row.companyName,
                        },
                      }"
                      style="margin: 0"
                    >
                      <vs-button
                        icon="icon-eye"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        class="custom-border-btn"
                        v-has-permission="permission80"
                        >{{ $t("Quota") }}</vs-button
                      >
                    </router-link>
                    <vs-button
                      icon="icon-plus"
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="custom-border-btn"
                      @click="onShowAddUser(row)"
                      v-has-permission="permission678"
                      >{{ $t("AssignUsers") }}</vs-button
                    >
                    <vs-button
                      icon="icon-eye"
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      class="custom-border-btn"
                      @click="onShowSalesPersons(row.id)"
                      v-has-permission="permission280"
                      >{{ $t("SalesPersons") }}</vs-button
                    >
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <user-popup
          :show="isShowUserPopup"
          :currentAgentData="currentAgentData"
          @finish="onfinish"
        ></user-popup>
        <sales-persons-popup
          :show="isShowSalesPersonsPopup"
          :agentId="agentId"
          @finish="onfinish"
        ></sales-persons-popup>
        <agent-segment-popup
          :show="isShowAgentSegmentPopup"
          :agentId="agentId"
          :agentName="agentName"
          @finish="onfinish"
        ></agent-segment-popup>
      </div>
    </div>
  </div>
</template>
<style scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_l_green {
  cursor: pointer;
}

.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}

.filter-form {
  border-top: 1px dashed #ddd;
  padding-top: 0.5rem;
}

.filter-form
  .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding: 0.5rem 2rem;
}
</style>
<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import UserPopup from "./UserPopup.vue";
import SalesPersonsPopup from "./SalesPersonsPopup.vue";
import AgentSegmentPopup from "./AgentSegmentPopup.vue";
import FilterButton from "@/components/buttons/FilterButton.vue";
import utils from "@/assets/utils/index";

export default {
  data() {
    return {
      permission319: "CreateAgentLegalByExcelFile",
      permission1319: "GetAllAgentSegmentWithSalePersonInfo",
      permission320: "CreateAgentIndividualByExcelFile",
      permission78: "CreateAgentLegal|CreateAgentIndividual",
      permission678: "AssignAgentLegalMember",
      permission878: "AssignAgentLegalMember",
      permission80: "GetAllSaleAgentQuota",
      permission280: "GetAllByOwnerId",
      permission240: "GetAllByAgentInfo",
      permission81: "GetAgentRecipientsByOwnerIdInShipping|GetAgentById",
      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/AgentsInfoQuery",
      },
      gridSearchData: {},
      showFilters: false,
      customers: [
        { name: "حقیقی", id: 1 },
        { name: "حقوقی", id: 2 },
      ],
      fileForLegal: "",
      fileForIndividual: "",
      agentName: "",
      fileUploadedForLegal: false,
      disabledBtnForLegal: false,
      uploadedFileNameForLegal: "",
      fileUploadedForIndividual: false,
      disabledBtnForIndividual: false,
      isShowUserPopup: false,
      isShowAgentSegmentPopup: false,
      isShowAgentBranchPopup: false,
      isShowSalesPersonsPopup: false,
      currentAgentData: {},
      uploadedFileNameForIndividual: "",
      emptyFileInRefs: "",
      agentId: "",
      excelFileLoading: false,
    };
  },
  mounted() {
    this.emptyFileInRefs = null;
  },
  methods: {
    ...mapActions({
      importAgentIndividuals: "excel/importAgentIndividuals",
      importAgentLegals: "excel/importAgentLegals",
      exportAgents: "excel/exportAgents",
    }),
    downloadExcelFile() {
      this.excelFileLoading = true;
      var params = utils.toQueryString(this.gridSearchData);
      this.exportAgents(params)
        .then(() => {
          this.excelFileLoading = false;
        })
        .catch(() => {
          this.excelFileLoading = false;
        });
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    onShowAddUser(agentData) {
      this.isShowUserPopup = true;
      this.currentAgentData = agentData;
    },
    onShowSalesPersons(agentId) {
      this.isShowSalesPersonsPopup = true;
      this.agentId = agentId;
    },
    onShowAgentSegment(data) {
      this.agentId = data.id;
      this.agentName = data.name;
      this.isShowAgentSegmentPopup = true;
    },
    onShowAddBranch(data) {
      this.agentId = data.id;
      this.isShowAgentBranchPopup = true;
    },
    handleFileUploadForLegal() {
      this.fileForLegal = this.$refs.fileForLegal.files[0];
      this.uploadedFileNameForLegal = this.fileForLegal.name;
      this.fileUploadedForLegal = true;
    },
    handleFileUploadForIndividual() {
      this.fileForIndividual = this.$refs.fileForIndividual.files[0];
      this.uploadedFileNameForIndividual = this.fileForIndividual.name;
      this.fileUploadedForIndividual = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFileForLegal() {
      this.disabledBtnForLegal = true;
      let formData = new FormData();
      formData.append("file", this.fileForLegal);
      this.importAgentLegals(formData).then(() => {
        this.successRequestImportExcel();
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtnForLegal = false;
      }, 1000);
    },

    uploadFileForIndividual() {
      this.disabledBtnForIndividual = true;
      let formData = new FormData();
      formData.append("file", this.fileForIndividual);
      this.importAgentIndividuals(formData).then(() => {
        this.successRequestImportExcel();
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtnForIndividual = false;
      }, 1000);
    },
    successRequestImportExcel() {
      this.fileUploadedForLegal = false;
      this.fileUploadedForIndividual = false;

      setTimeout(() => {
        this.$refs.grid.renderGrid();
        this.uploadedFileNameForLegal = "";
        this.uploadedFileNameForIndividual = "";
      }, 5000);
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.gridSearchData = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid();
        this.$refs.agentype.clearSelection();
      }, 0);
    },
    onfinish() {
      this.isShowUserPopup = false;
      this.isShowSalesPersonsPopup = false;
      this.isShowAgentSegmentPopup = false;
      this.isShowAgentBranchPopup = false;
    },
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    UserPopup,
    AgentSegmentPopup,
    SalesPersonsPopup,
    FilterButton,
  },
};
</script>
